<div class="m-t-2 p-a-2 p-a-4-m p-a-4-s flex flex-justify-between flex-top b-radius-7 bg-col-5">
    <div class="flex-grow">
        @if(billingAddressModel) {
        <checkout-address-model [model]="billingAddressModel" />
        }
    </div>

    <button type="button"
            (click)="change()">
        <span [sizeClass]="'SM: fs-3 fw-bold, XL: s2'">{{'Change' | translate}}</span>
    </button>
</div>
